import { Injectable } from '@angular/core';
import SimpleMDE from 'simplemde/dist/simplemde.min.js';

@Injectable({
  providedIn: 'root'
})
export class SimpleMDEService {

  simpleMarkdownEditor: any;
  element: any;

  constructor() {
  }

  getEditor(element) {
      this.unbind();
      this.element = element;
      this.simpleMarkdownEditor = new SimpleMDE({
          element : element,
          spellChecker: false,
          autofocus: true,
          toolbar: ['bold', 'italic', 'heading', '|', 'quote', 'unordered-list',
              'ordered-list', '|', 'link', '|', 'preview', 'fullscreen', 'guide']
      });
      return this.simpleMarkdownEditor;
  }

  getHtml(value) {
      return SimpleMDE.prototype.markdown( value ).replace(/<\/?p>/g, '');
  }

  getValue() {
     return this.simpleMarkdownEditor.value();
  }

  unbind() {
    if(this.simpleMarkdownEditor){
        this.simpleMarkdownEditor.toTextArea();
        this.simpleMarkdownEditor = null;
        this.element = null;
    }
  }
}
